function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { registerAction, unregisterAction } from 'helpers/reducerTools';
import * as actionTypes from './actionTypes';
const initialState = {
    exportName: null,
    progress: 0,
    fetching: [],
    sending: [],
    errors: []
};
export default function reducer(state = _object_spread({}, initialState), action = {}) {
    switch(action.type){
        case actionTypes.SET_PROGRESS:
            {
                const { progress } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    progress
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.EXPORT_DATA:
            {
                const { exportName } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    exportName,
                    progress: 0,
                    fetching: registerAction(state.fetching, actionTypes.EXPORT_DATA),
                    errors: unregisterAction(state.errors, actionTypes.EXPORT_DATA)
                });
            }
        case actionTypes.EXPORT_DATA_CANCEL:
            {
                return _object_spread_props(_object_spread({}, state), {
                    exportName: null,
                    progress: 0,
                    fetching: unregisterAction(state.fetching, actionTypes.EXPORT_DATA)
                });
            }
        case actionTypes.EXPORT_DATA_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.EXPORT_DATA)
                });
            }
        case actionTypes.EXPORT_DATA_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.EXPORT_DATA),
                    errors: registerAction(state.errors, actionTypes.EXPORT_DATA)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        default:
            {
                return state;
            }
    }
}
